import type { ReactNode } from 'react';

import type { ApiState } from '../hooks/useApi';
import { useT } from '../i18n/LanguageProvider';

interface Props<T> {
  state: ApiState<T>;
  children: (data: T) => ReactNode;
}

/** Enhetlig hantering av laddning och fel för allt API-drivet innehåll. */
export default function AsyncContent<T>({ state, children }: Props<T>) {
  const t = useT();

  if (state.status === 'loading') {
    return (
      <div className="state" role="status">
        {t.common.loading}
      </div>
    );
  }

  if (state.status === 'error') {
    return (
      <div className="state is-error" role="alert">
        {t.common.loadError}
      </div>
    );
  }

  return <>{children(state.data)}</>;
}
